import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface addSupplierFields {
    name?: string;
    account_no?: string;
    serial_no?: string;
    phone?: string;
    fax?: string;
    mobile?: string;
    email?: string;
    website?: string;
    country?: string;
    government?: string;
    city?: string;
    postal_code?: string;
    department_number?: string;
    address_1?: string;
    address_2?: string;
    address_3?: string;
}

// Add supplier state
export interface addSupplierState {
    fields: addSupplierFields;
    editId: number;
    isLoading: boolean;
    isSuccess: boolean;
    isOpen: boolean;
}

const initialAddSupplierState: addSupplierState = {
    fields: {},
    editId: 0,
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Add supplier slice
export const addSupplierSlice = createSlice({
    name: 'add_supplier',
    initialState: initialAddSupplierState,
    reducers: {
        init: state => initialAddSupplierState,
        set: ( state, {payload}: PayloadAction<addSupplierFields> ) => {
            state.fields = { ...state.fields, ...payload }
        },
        setEditId: ( state, {payload}: PayloadAction<number> ) => {
            state.editId = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsSuccess: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isSuccess = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isOpen = payload
        },
    }
})